import "../../design/errorPage.css";
import {WEBSITE_URL} from "../../api/API_SERVERS";

export default function ErrorPage() {
    const redirectToMainPage = () => {
        window.location.assign(WEBSITE_URL);
    }

    return (
        <>
            <div className={'errorPage'}>
                <div>
                    <div className={'errorPageTitle'}>Oops!</div>
                    <div className={'errorPage404'}>404 - Page not found</div>
                    <div className={'errorPageText'}>The page you are looking for might have been removed had its name changed or is temporarily
                        unavailable.
                    </div>
                    <button className={'errorPageHomePageButton'} onClick={redirectToMainPage}>Go to home page</button>
                </div>
            </div>
        </>
    )
}